import {
  COMMERCIAL_ROLE,
  RECRUITER_ROLE,
  SUPER_ADMIN_ROLE,
} from 'helper/roles';

const withRole = (team, role) => team.filter((person) => person.role === role);

// The Commercials (510) alone, without the agency managers the api would also
// take: whom « Marquer comme perdu » gives the relaunch, whose call goals the
// console sets.
export const commercialsOnly = (team) => withRole(team, COMMERCIAL_ROLE);

// The recruiters (520) alone: whom « Passer en ancien client » gives the company.
export const recruitersOnly = (team) => withRole(team, RECRUITER_ROLE);

// A company's sales rep is one of those who prospect: a Commercial (510) or
// an agency manager (500), the commercials first. The api refuses anyone else
// (INVALID_ASSIGNEE), and the team it sends holds active users only.
export const commercialsOf = (team) => [
  ...commercialsOnly(team),
  ...withRole(team, SUPER_ADMIN_ROLE),
];

// A company's recruiter is a recruiter, or failing that an agency manager:
// the 520 first, then the 500.
export const recruitersOf = (team) => [
  ...recruitersOnly(team),
  ...withRole(team, SUPER_ADMIN_ROLE),
];
